export default __webpack_public_path__ + "static/media/Label_Tickets_inv.49da539a.png";